

// ----------------------------------------------------------------
// Define and export update profile data
// ----------------------------------------------------------------

export const updateProfileData = (userData) => {
  const data = {
    firstName: {
      value: userData?.personalInfo?.firstName || "",
      error: "",
      focus: null,
    },

    lastName: {
      value: userData?.personalInfo?.surName || "",
      error: "",
      focus: null,
    },
    nickName: {
      value: userData?.personalInfo?.nickName || "",
      error: "",
      focus: null,
    },
    doc: {
      value: userData?.docs || "",
      error: "",
      focus: null,
    },
    gender: {
      value: userData?.personalInfo?.gender || "",
      error: "",
      focus: null,
    },
    
    empType: {
      value: userData?.additionalInformation?.empType || "",
      error: "",
      focus: null,
    },

    mobile: {
      value: userData?.personalInfo?.mobile || "",
      error: "",
      focus: null,
    },
    password: {
      value: "",
      error: "",
      focus: null,
    },
    confirmPassword: {
      value: "",
      error: "",
      focus: null,
    },
    jobPosition: {
      value: userData?.personalInfo?.jobPosition[0] || "",
      error: "",
      focus: null,
    },
    department: {
      value: userData?.personalInfo?.department || "",
      error: "",
      focus: null,
    },
    operator: {
      value: userData?.personalInfo?.operator || "",
      error: "",
      focus: null,
    },
    address1: {
      value: userData?.personalInfo?.addressLine1 || "",
      error: "",
      focus: null,
    },
    address2: {
      value: userData?.personalInfo?.addressLine2 || "",
      error: "",
      focus: null,
    },
    city: { value: userData?.personalInfo?.city || "", error: "", focus: null },
    zipCode: {
      value: userData?.personalInfo?.zipCode || "",
      error: "",
      focus: null,
    },
    country: {
      value: userData?.personalInfo?.country || "",
      error: "",
      focus: null,
    },
    email: {
      value: userData?.personalInfo?.email || "",
      error: "",
      focus: null,
    },
    dob: { value: userData?.personalInfo?.dob || "", error: "", focus: null },
    education: {
      value: userData?.personalInfo?.education || "",
      error: "",
      focus: null,
    },
    salary: {
      value: userData?.salaryInfo?.salary || 0,
      error: "",
      focus: null,
    },
    restraintTrade: {
      value: userData?.salaryInfo?.restraintTrade || 0,
      error: "",
      focus: null,
    },
    annualBonus: {
      value: userData?.salaryInfo?.annualBonus || "",
      error: "",
      focus: null,
    },
    payfreq: {
      value: userData?.salaryInfo?.payfreq || "",
      error: "",
      focus: null,
    },
    paymentType: {
      value: userData?.salaryInfo?.paymentType || "",
      error: "",
      focus: null,
    },
    rateRembTravel: {
      value: userData?.salaryInfo?.rateRembTravel || "",
      error: "",
      focus: null,
    },

    increment: {
      value: userData?.salaryInfo?.increment || "",
      error: "",
      focus: null,
    },

    profileImg: {
      value: userData?.personalInfo?.image || "",
      error: "",
      focus: null,
    },
    payrollName: {
      value: userData?.salaryInfo?.payrollName || "",
      error: "",
      focus: null,
    },
    status: {
      value: userData?.salaryInfo?.status || "",
      error: "",
      focus: null,
    },
    leaveBalance: {
      value: userData?.salaryInfo?.leaveB || 0,
      error: "",
      focus: null,
    },
    nationality: {
      value: userData?.otherInformation?.nationality || "",
      error: "",
      focus: null,
    },
    religion: {
      value: userData?.otherInformation?.religion || "",
      error: "",
      focus: null,
    },
    empNumber: {
      value: userData?.empId || "",
      error: "",
      focus: null,
    },

    marital: {
      value: userData?.otherInformation?.martial || "",
      error: "",
      focus: null,
    },
    passportNum: {
      value: userData?.otherInformation?.passportNo || "",
      error: "",
      focus: null,
    },
    emergencyContact: {
      value: userData?.otherInformation?.emergencyContact,
      error: "",
      focus: null,
    },

    workplace: {
      value: userData?.otherInformation?.workplace,
      error: "",
      focus: null,
    },
    hourlyRate: {
      value: userData?.salaryInfo?.hRate || "",
      error: "",
      focus: null,
    },
    bankName: { value: userData?.bankInfo?.bank || "", error: "", focus: null },
    accountNum: {
      value: userData?.bankInfo?.account || "",
      error: "",
      focus: null,
    },
    ifscCode: {
      value: userData?.bankInfo?.bankCode || "",
      error: "",
      focus: null,
    },
    accountHolder: {
      value: userData?.bankInfo?.accountHolder || "",
      error: "",
      focus: null,
    },
    personalTaxCode: {
      value: userData?.bankInfo?.taxCode || "",
      error: "",
      focus: null,
    },
    issuedDate: {
      value: userData?.bankInfo?.issuedDate || "",
      error: "",
      focus: null,
    },
    accountType: {
      value: userData?.bankInfo?.acType || "",
      error: "",
      focus: null,
    },

    joiningDate: {
      value: userData?.experience?.joiningDate || "",
      error: "",
      focus: null,
    },
    start: {
      value: userData?.additionalInformation?.contractor?.start || "",
      error: "",
      focus: null,
    },
    end: {
      value: userData?.additionalInformation?.contractor?.end || "",
      error: "",
      focus: null,
    },

    experience: {
      value: userData?.experience?.exp || "",
      error: "",
      focus: null,
    },
    profileVisibility: {
      value: userData?.additionalInformation?.isprofile || "",
      error: "",
      focus: null,
    },
    isActive: {
      value: userData?.isActive || "",
      error: "",
      focus: null,
    },

    isOverTime: {
      value: userData?.additionalInformation?.isOverTime || "",
      error: "",
      focus: null,
    },
    rate: {
      value: userData?.additionalInformation?.overTimeRate || 0,
    },
    isExtraTime: {
      value: userData?.additionalInformation?.isExtraTime || "",
      error: "",
      focus: null,
    },
    extraTimeRate: {
      value: userData?.additionalInformation?.extraTimeRate || "",
    },
    isDoubleOverTime: {
      value: userData?.additionalInformation?.isDoubleOverTime || "",
      error: "",
      focus: null,
    },
    doubleOverTimeRate: {
      value: userData?.additionalInformation?.doubleOverTimeRate || "",
    },

    isPreAttendance: {
      value: userData?.additionalInformation?.isPreAttendance || "",
      error: "",
      focus: null,
    },

    taskNoti: {
      value: userData?.additionalInformation?.istasknoti || "",
      error: "",
      focus: null,
    },
    isTracked: {
      value: userData?.additionalInformation?.isTracked || "",
      error: "",
      focus: null,
    },

    urlSkype: {
      value: userData?.socialMedia?.skype || "",
      error: "",
      focus: null,
    },
    urlLinkedin: {
      value: userData?.socialMedia?.linkedIn || "",
      error: "",
      focus: null,
    },
    urlInsta: {
      value: userData?.socialMedia?.instagram || "",
      error: "",
      focus: null,
    },
    urlFb: {
      value: userData?.socialMedia?.facebook || "",
      error: "",
      focus: null,
    },
    idNumber: {
      value: userData?.taxInfo?.idNumber || "",
      error: "",
      focus: null,
    },
    taxRefNo: {
      value: userData?.taxInfo?.taxRefNo || "",
      error: "",
      focus: null,
    },
    medicalAidNo: {
      value: userData?.taxInfo?.medicalAidNo || "",
      error: "",
      focus: null,
    },
    projects: {
      value: userData?.projects || [],
      error: "",
      focus: null,
    },
    additionalBeneficiariesNo: {
      value: userData?.additionalInformation?.additional_beneficiary_no || "",
      error: "",
      focus: null,
    },
  }
  return data;
};


export const nationalities = [
  "Afghan",
  "Albanian",
  "Algerian",
  "American",
  "Andorran",
  "Angolan",
  "Antiguan and Barbudan",
  "Argentine",
  "Armenian",
  "Australian",
  "Austrian",
  "Azerbaijani",
  "Bahamian",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Barbudan",
  "Belgian",
  "Belizean",
  "Beninese",
  "Bhutanese",
  "Bolivian",
  "Bosnian",
  "Brazilian",
  "British",
  "Bruneian",
  "Bulgarian",
  "Burkinabe",
  "Burmese",
  "Burundian",
  "Cambodian",
  "Cameroonian",
  "Canadian",
  "Cape Verdean",
  "Central African",
  "Chadian",
  "Chilean",
  "Chinese",
  "Colombian",
  "Comorian",
  "Congolese",
  "Costa Rican",
  "Croatian",
  "Cuban",
  "Cypriot",
  "Czech",
  "Danish",
  "Djiboutian",
  "Dominican",
  "Dominican Republic",
  "Dutch",
  "East Timorese",
  "Ecuadorean",
  "Egyptian",
  "Emirati",
  "Equatorial Guinean",
  "Eritrean",
  "Estonian",
  "Eswatini",
  "Ethiopian",
  "Fijian",
  "Filipino",
  "Finnish",
  "French",
  "Gabonese",
  "Gambian",
  "Georgian",
  "German",
  "Ghanaian",
  "Greece",
  "Grenadian",
  "Guatemalan",
  "Guinea-Bissau",
  "Guinean",
  "Guyanese",
  "Haitian",
  "Honduran",
  "Hungarian",
  "Icelander",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivorian",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazakhstani",
  "Kenyan",
  "Kittian and Nevisian",
  "Korean",
  "Kuwaiti",
  "Kyrgyzstani",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Liberian",
  "Libyan",
  "Liechtenstein",
  "Lithuanian",
  "Luxembourgian",
  "Macedonian",
  "Malagasy",
  "Malawian",
  "Malaysian",
  "Maldivian",
  "Malian",
  "Malta",
  "Marshallese",
  "Mauritanian",
  "Mauritian",
  "Mexican",
  "Micronesian",
  "Moldovan",
  "Monacan",
  "Mongolian",
  "Moroccan",
  "Mozambican",
  "Namibian",
  "Nauruan",
  "Nepalese",
  "Dutch",
  "New Zealand",
  "Nicaraguan",
  "Nigerian",
  "Nigerien",
  "Norwegian",
  "Omani",
  "Pakistani",
  "Palauan",
  "Panamanian",
  "Papua New Guinean",
  "Paraguayan",
  "Peruvian",
  "Polish",
  "Portuguese",
  "Qatari",
  "Romanian",
  "Russian",
  "Rwandan",
  "Saint Lucian",
  "Salvadoran",
  "Samoan",
  "San Marinese",
  "Sao Tomean",
  "Saudi Arabian",
  "Senegalese",
  "Serbian",
  "Seychellois",
  "Sierra Leonean",
  "Singaporean",
  "Slovakian",
  "Slovenian",
  "Solomon Islander",
  "Somali",
  "South African",
  "Spanish",
  "Sri Lankan",
  "Sudanese",
  "Surinamese",
  "Swazi",
  "Swedish",
  "Swiss",
  "Syrian",
  "Taiwanese",
  "Tajikistani",
  "Tanzanian",
  "Thai",
  "Togolese",
  "Tongan",
  "Trinidadian or Tobagonian",
  "Tunisian",
  "Turkish",
  "Turkmen",
  "Tuvaluan",
  "Ugandan",
  "Ukrainian",
  "Uruguayan",
  "Uzbekistani",
  "Vanuatu",
  "Venezuelan",
  "Vietnamese",
  "Yemenite",
  "Zambian",
  "Zimbabwean"
]